<template>
  <v-chip
    v-if="isDevMode"
    class="mr-4"
    closable
    color="warning"
    prepend-icon="mdi-alert-circle-outline"
    @click:close="isDevMode = false"
  >
    Developer Mode
  </v-chip>
</template>

<script setup>
  import { useDevMode } from '#xapp-core/foundation'

  const { isDevMode } = useDevMode()
</script>
